import type { NextRouter } from "next/router";

type RouterLike = Pick<NextRouter, "pathname" | "query" | "asPath">;

// Short route-derived description of what the admin is currently viewing,
// sent as liveContext with every Opus Agent message.
export const getLiveContext = ({
  pathname,
  query,
  asPath,
}: RouterLike): string => {
  if (
    pathname === "/library/library-item/[id]" &&
    typeof query.id === "string"
  ) {
    return `Viewing library item ${query.id}`;
  }
  // /library and /library/forms open a builder in the right pane when
  // libraryItemId is present (same rule as isBuilderView).
  if (
    (pathname === "/library" || pathname === "/library/forms") &&
    typeof query.libraryItemId === "string"
  ) {
    return `Viewing library item ${query.libraryItemId}`;
  }
  return `Viewing ${asPath.split("?")[0] || pathname}`;
};
